export class Login {
  constructor(
    public session?: Session,
    public token?: string
  ) {
  }
}

export class Session {
  constructor(
    public publicid?: string,
    public username?: string,
    public enabled?: boolean,
    public profile?: Profile[]
  ) {
  }
}

export class Profile {
  constructor(
    public description?: string,
    public enabled?: boolean,
    public permit?: string[]
  ) {
  }
}

// Un usuario puede tener varios perfiles: sus permisos son la unión de los de todos los perfiles habilitados.
export function sessionPermits(session?: Session): string[] {
  const permits = (session?.profile ?? [])
    .filter(profile => profile.enabled !== false)
    .flatMap(profile => profile.permit ?? []);
  return [...new Set(permits)];
}

export function sessionProfileDescription(session?: Session): string {
  return (session?.profile ?? [])
    .filter(profile => profile.enabled !== false)
    .map(profile => profile.description)
    .join(', ');
}
